<template>
  <div :class="`ribbon ribbon-${position}`" :style="cssProps">
    <span :style="{ backgroundColor: bgColor }">{{ text }}</span>
  </div>
</template>

<script>
  export default {
    name: 'Ribbon',

    props: {
      text: String,
      bgColor: String,
      position: String,
    },

    computed: {
      cssProps() {
        return {
          '--bg-ribbon-color': this.bgColor
        }
      }
    }
  }
</script>

<style>
  .ribbon {
    width: 150px;
    height: 150px;
    overflow: hidden;
    position: absolute;
  }

  .ribbon::before,
  .ribbon::after {
    position: absolute;
    z-index: 2;
    content: '';
    display: block;
    border: 5px solid var(--bg-ribbon-color);
  }
  .ribbon span {
    position: absolute;
    display: block;
    width: 225px;
    padding: 7px 0;
    background-color: var(--bg-ribbon-color);
    box-shadow: 0 2px 1px rgba(0,0,0,.1);
    color: #fff;
    font: 500 16px/1 'Lato', sans-serif;
    text-shadow: 0 1px 1px rgba(0,0,0,.2);
    text-transform: uppercase;
    text-align: center;
    z-index: 2;
  }

  /* top right*/
  .ribbon-top-right {
    top: -10px;
    right: -10px;
  }
  .ribbon-top-right::before,
  .ribbon-top-right::after {
    border-top-color: transparent;
    border-right-color: transparent;
  }
  .ribbon-top-right::before {
    top: 0;
    left: 22px;
  }
  .ribbon-top-right::after {
    bottom: 22px;
    right: 0;
  }
  .ribbon-top-right span {
    left: -18px;
    top: 36px;
    transform: rotate(45deg);
  }

</style>